import { RouterManager } from '@aclass/admin/managers';
import { EmailTemplateStory } from '@aclass/admin/storage/actions';
import { IAdminState, IEmailTemplateModuleState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';

@Injectable()
export class EmailTemplateSearchStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:email-template-search';

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<IEmailTemplateModuleState['searchPageInitialized']>(['emailTemplateModule', 'searchPageInitialized']).pipe(
            filter(v => v)
        );
        this.employee = this.routerManager.onRejectNavigation(EmailTemplateSearchStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(): void {
        this.ngRdx.dispatch(EmailTemplateStory.dryRunSearchPage());
    }
}
